<template>
    <v-select
        v-model="language"
        :items="languageValue"
    >
      <template slot="selection" slot-scope="data">
        <img :src="data.item.avatar" width="20px" alt="avatar">&nbsp;&nbsp;{{data.item.text}}
      </template>
      <template slot="item" slot-scope="data">
            <img :src="data.item.avatar" width="20px" alt="avatar">&nbsp;&nbsp;{{data.item.text}}
      </template>
    </v-select>
</template>

<script>
import { mapState } from 'vuex'
import { apiAxios, setApiLangId } from '../../../helpers'
export default {
  name: 'LSelect',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      language: localStorage.getItem('locale') || 'es'
    }
  },
  watch: {
    language: function (val) {
      this.changeLocale(val)
    },
    listLanguages: function (val) {
      if (val && !localStorage.getItem('langId')) { this.setLangId('es') }

      if (val && !localStorage.getItem('defaultLangId')) {
        const language = this.listLanguages.find(language => language.iso.split('-')[0] == 'es')
        const defaultLangId = language ? language._id : '5bd9f3ee7fa5610014fed21e'
        localStorage.setItem('defaultLangId', defaultLangId)
      }
    }
  },
  computed: {
    ...mapState({
      listLanguages: state => state.languages.listLanguages
    }),
    languageValue () {
      let result = []
      this.items.forEach(item => {
        result.push({
          text: item.title,
          value: item.language,
          avatar: `/static/flags/${item.flag}.svg`
        })
      })
      return result
    }
  },
  methods: {
    changeLocale (locale) {
      this.$i18n.locale = locale
      this.$vuetify.lang.current = locale
      localStorage.setItem('locale', locale)
      this.setLangId(locale)
    },
    setLangId (locale) {
      if (!this.listLanguages) return
      const language = this.listLanguages.find(language => language.iso.split('-')[0] == locale)
      if (!language) language = this.listLanguages.find(language => language.iso.split('-')[0] == 'es')
      const langId = language ? language._id : '5bd9f3ee7fa5610014fed21e'
      localStorage.setItem('langId', langId)
      setApiLangId(langId)
    }
  }
}
</script>
